import { useEffect, useRef } from "react";
import DesktopModal from "./modal.desktop";
import ModalMobile from "./modal.mobile";
import { useIsMobile } from "@hooks/useIsMobile";

export default function Modal({ size = "small", isOpen, onClose, ...props }) {
  const isMobile = useIsMobile();
  const hasModalState = useRef(false);

  useEffect(() => {
    if (!isOpen || hasModalState.current) return;

    // ✅ replace instead of push
    window.history.replaceState(
      { ...window.history.state, modal: true },
      ""
    );
    hasModalState.current = true;

    const onBack = () => {
      onClose?.();
    };

    window.addEventListener("popstate", onBack);

    return () => {
      window.removeEventListener("popstate", onBack);
      hasModalState.current = false;
    };
  }, [isOpen, onClose]);

  const ModalComponent =
    isMobile && size === "small" ? ModalMobile : DesktopModal;

  return <ModalComponent isOpen={isOpen} onClose={onClose} {...props} />;
}
